<script>
  export let showLegend = false;
  export let showNA = false;
</script>
<fieldset class="capacity-legend">

  {#if showLegend}
    <legend>Capacity level</legend>
  {/if}
  <ul>
    <li>
      <label for="map-legend-1" data-capacity="1">
        <input type="checkbox" name="map-legend" value="1" data-capacity="1" id="map-legend-1">
        <span>Nascent <!-- <span class="infotip" data-tip="Nascent"></span> --></span>
      </label>
    </li>
    <li>
      <label for="map-legend-2" data-capacity="2">
        <input type="checkbox" name="map-legend" value="2" data-capacity="2" id="map-legend-2">
        <span>Limited <!-- <span class="infotip" data-tip="Limited"></span> --></span>
      </label>
    </li>
    <li>
      <label for="map-legend-3" data-capacity="3">
        <input type="checkbox" name="map-legend" value="3" data-capacity="3" id="map-legend-3">
        <span>Moderate <!-- <span class="infotip" data-tip="Moderate"></span> --></span>
      </label>
    </li>
    <li>
      <label for="map-legend-4" data-capacity="4">
        <input type="checkbox" name="map-legend" value="4" data-capacity="4" id="map-legend-4">
        <span>Well-developed <!-- <span class="infotip" data-tip="Well-developed"></span> --></span>
      </label>
    </li>
    <li>
      <label for="map-legend-5" data-capacity="5">
        <input type="checkbox" name="map-legend" value="5" data-capacity="5" id="map-legend-5">
        <span>Sustainable <!-- <span class="infotip" data-tip="Sustainable"></span> --></span>
      </label>
    </li>
    {#if showNA}
      <div class="break"></div>
      <li>
        <label for="liconflict" class="liconflict">
          <input type="checkbox" id="liconflict">
          <span>Not applicable</span>
        </label>
      </li>
      <li>
        <label for="linotavailable" class="linotavailable">
          <input type="checkbox" id="linotavailable">
          <span>Not participated</span>
        </label>
      </li>
    {/if}
  </ul>
</fieldset>
